export default __webpack_public_path__ + "static/media/image_prod_png.04cf3b3b.png";